import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'yt-fw-search-box',
  templateUrl: './search-box.component.html',
   styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent {
  @Input() disabled: boolean = false;
@Output() search = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  searchText: string = '';

onSearchClick() {
  this.search.emit(this.searchText); 
}

  onClearClick() {
    this.searchText = '';
    this.clear.emit();
  }

  onKeyDown(event: KeyboardEvent) {
  if (event.key === 'Enter' && !this.disabled) {
    this.onSearchClick();
  }
}

}
